import { FC, useState } from "react";
import avatar from "src/assets/images/header/avatar.svg";

const statusTabs = ["All", "Escrow"];

const BookingInvoicesModal: FC<{
	open: boolean;
	handleClose: () => void;
	bookingTransaction: TransactionTypes[];
	customerName: string;
	vendorName: string;
	customerAvatar?: string;
	vendorAvatar?: string;
	escrowTransactions: TransactionTypes[];
	currency_symbol: string;
}> = ({
	open,
	handleClose,
	bookingTransaction,
	customerName,
	vendorName,
	customerAvatar,
	vendorAvatar,
	escrowTransactions,
	currency_symbol,
}) => {
	const [tab, setTab] = useState("All");
	if (!open) return null;

	const commitmentFeeObj = bookingTransaction.find(
		(trx) => trx.narration === "commitment-fee"
	);

	const commitmentFee = commitmentFeeObj?.amount || 0;

	const bookingTrxFiltered = bookingTransaction.filter(
		(trx) => trx.narration !== "commitment-fee"
	);

	const bookingTrx = bookingTrxFiltered.map((trx) => {
		if (trx.narration === "service-fee") {
			return {
				...trx,
				amount: commitmentFee + trx.amount,
			};
		}
		return trx;
	});

	const filtered =
		tab === "All" ? bookingTrx : tab === "Escrow" ? escrowTransactions : [];
	return (
		<>
			<div
				className='fixed inset-0 z-40 bg-black/30 transition-opacity'
				onClick={handleClose}
			/>
			<div className='fixed top-0 right-0 z-50 h-full w-full max-w-[520px] bg-white shadow-2xl flex flex-col'>
				{/* Header */}
				<div className='flex items-center gap-3 px-6 py-4 border-b border-gray-100 relative'>
					<button
						className='mr-2 p-1 rounded-full hover:bg-gray-100'
						onClick={handleClose}
					>
						<svg
							width='24'
							height='24'
							fill='none'
							stroke='currentColor'
							strokeWidth='2'
							viewBox='0 0 24 24'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M15 19l-7-7 7-7'
							/>
						</svg>
					</button>
					<div className='flex items-center gap-2 flex-1 justify-center'>
						<img
							src={customerAvatar || avatar}
							alt='customer'
							className='w-8 h-8 rounded-full border-2 border-white -mr-2 z-10'
						/>
						<img
							src={vendorAvatar || avatar}
							alt='vendor'
							className='w-8 h-8 rounded-full border-2 border-white z-0 -ml-2'
						/>
						<span className='text-sm font-medium text-gray-700 mr-2'>
							{customerName} & {vendorName}
						</span>
					</div>
					<button className='ml-auto p-1 rounded-full hover:bg-gray-100'>
						<svg
							width='24'
							height='24'
							fill='none'
							stroke='currentColor'
							strokeWidth='2'
							viewBox='0 0 24 24'
						>
							<circle cx='12' cy='6' r='1.5' />
							<circle cx='12' cy='12' r='1.5' />
							<circle cx='12' cy='18' r='1.5' />
						</svg>
					</button>
				</div>
				{/* Tabs */}
				<div className='flex gap-8 px-6 pt-4 pb-2 border-b border-gray-100'>
					{statusTabs.map((tabName) => (
						<button
							key={tabName}
							className={`pb-2 font-semibold ${
								tab === tabName
									? "text-purple-600 border-b-2 border-purple-600"
									: "text-gray-400"
							}`}
							onClick={() => setTab(tabName)}
						>
							{tabName}
						</button>
					))}
				</div>
				{/* Table */}
				<div className='flex-1 overflow-y-auto px-6 py-4 bg-white'>
					{filtered.length > 0 ? (
						<table className='w-full text-left'>
							<thead>
								<tr className='text-gray-400 text-sm'>
									<th className='font-normal pb-2'>Narration</th>
									<th className='font-normal pb-2'>Amount</th>
									<th className='font-normal pb-2'>Status</th>
								</tr>
							</thead>
							<tbody>
								{filtered.map((trx) => (
									<tr key={trx._id}>
										<td className='py-2 first-letter:uppercase'>
											{trx.narration.split("_").join(" ").split("-").join(" ")}
										</td>
										<td className='py-2 font-bold'>
											{currency_symbol}
											{Number(trx.amount).toLocaleString(undefined, {
												minimumFractionDigits: 2,
											})}
										</td>
										<td className='py-2'>{trx.status}</td>
									</tr>
								))}
							</tbody>
						</table>
					) : (
						<div className='text-center text-gray-400 py-8'>
							No invoice transactions available.
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default BookingInvoicesModal;
